var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import BaseApiClient from '@/plugins/apis/base-api-client';
export { validateImageFile } from '@/plugins/utils/image-validation';
var resourceName = 'content_comment';
var ContentCommentApi = /** @class */ (function (_super) {
    __extends(ContentCommentApi, _super);
    function ContentCommentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ContentCommentApi.prototype, "basePath", {
        get: function () {
            var companyId = this.companyId;
            return "/companies/" + companyId + "/contents";
        },
        enumerable: false,
        configurable: true
    });
    ContentCommentApi.prototype.buildFormData = function (_a) {
        var text = _a.text, mentionedUids = _a.mentionedUids, images = _a.images, deleteImageIds = _a.deleteImageIds, contentIds = _a.contentIds, unlinkContentIds = _a.unlinkContentIds, pin = _a.pin, parentId = _a.parentId;
        var fd = new FormData();
        fd.append('content_comment[body]', text.trim());
        mentionedUids.forEach(function (uid) { return fd.append('content_comment[mentioned_uids][]', uid); });
        images === null || images === void 0 ? void 0 : images.forEach(function (image) { return fd.append('content_comment[images][]', image); });
        deleteImageIds === null || deleteImageIds === void 0 ? void 0 : deleteImageIds.forEach(function (id) { return fd.append('content_comment[delete_image_ids][]', id); });
        contentIds === null || contentIds === void 0 ? void 0 : contentIds.forEach(function (id) { return fd.append('content_comment[content_ids][]', id); });
        unlinkContentIds === null || unlinkContentIds === void 0 ? void 0 : unlinkContentIds.forEach(function (id) { return fd.append('content_comment[unlink_content_ids][]', id); });
        if (pin) {
            fd.append('content_comment[pin][coordinate_ratio_x]', String(pin.coordinate_ratio_x));
            fd.append('content_comment[pin][coordinate_ratio_y]', String(pin.coordinate_ratio_y));
            if (pin.page !== undefined) {
                fd.append('content_comment[pin][page]', String(pin.page));
            }
        }
        if (parentId) {
            fd.append('content_comment[parent_id]', parentId);
        }
        return fd;
    };
    ContentCommentApi.prototype.fetchComments = function (contentId) {
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments";
        return this.client.get(url, {
            params: {
                limit: 500
            }
        });
    };
    ContentCommentApi.prototype.fetchReplies = function (_a) {
        var contentId = _a.contentId, commentId = _a.commentId;
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments/" + commentId + "/replies";
        return this.client.get(url);
    };
    ContentCommentApi.prototype.createComment = function (_a) {
        var contentId = _a.contentId, text = _a.text, mentioned_uids = _a.mentioned_uids, pin = _a.pin, images = _a.images, contentIds = _a.contentIds, parentId = _a.parentId;
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments";
        var hasImages = images && images.length > 0;
        var hasContentIds = contentIds && contentIds.length > 0;
        if (hasImages || hasContentIds) {
            return this.requestActionWithNamedProperty({
                url: url,
                method: 'post',
                data: this.buildFormData({
                    text: text,
                    mentionedUids: mentioned_uids,
                    images: images,
                    contentIds: contentIds,
                    pin: pin,
                    parentId: parentId
                }),
                actionName: 'POST',
                resourceName: resourceName
            });
        }
        return this.requestActionWithNamedProperty({
            url: url,
            method: 'post',
            data: {
                content_comment: __assign({ body: text.trim(), mentioned_uids: mentioned_uids,
                    pin: pin }, (parentId ? { parent_id: parentId } : {}))
            },
            actionName: 'POST',
            resourceName: resourceName
        });
    };
    ContentCommentApi.prototype.updatePin = function (_a) {
        var contentId = _a.contentId, commentId = _a.commentId, pin = _a.pin;
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments/" + commentId;
        return this.requestActionWithNamedProperty({
            url: url,
            method: 'put',
            data: {
                content_comment: {
                    pin: pin
                }
            },
            actionName: 'UPDATE',
            resourceName: resourceName
        });
    };
    ContentCommentApi.prototype.deleteComment = function (_a) {
        var contentId = _a.contentId, commentId = _a.commentId;
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments/" + commentId;
        return this.requestActionWithNamedProperty({
            url: url,
            method: 'delete',
            actionName: 'DELETE',
            resourceName: resourceName
        });
    };
    ContentCommentApi.prototype.updateComment = function (_a) {
        var commentId = _a.commentId, contentId = _a.contentId, text = _a.text, mentionedUids = _a.mentionedUids, images = _a.images, deleteImageIds = _a.deleteImageIds, contentIds = _a.contentIds, unlinkContentIds = _a.unlinkContentIds;
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments/" + commentId;
        var hasImages = images && images.length > 0;
        var hasContentIds = contentIds && contentIds.length > 0;
        var hasDeleteIds = deleteImageIds && deleteImageIds.length > 0;
        var hasUnlinkIds = unlinkContentIds && unlinkContentIds.length > 0;
        if (hasImages || hasContentIds) {
            return this.requestActionWithNamedProperty({
                url: url,
                method: 'put',
                actionName: 'UPDATE',
                resourceName: resourceName,
                data: this.buildFormData({
                    text: text,
                    mentionedUids: mentionedUids,
                    images: images,
                    deleteImageIds: deleteImageIds,
                    contentIds: contentIds,
                    unlinkContentIds: unlinkContentIds
                })
            });
        }
        return this.requestActionWithNamedProperty({
            url: url,
            method: 'put',
            actionName: 'UPDATE',
            resourceName: resourceName,
            data: {
                content_comment: __assign(__assign({ body: text.trim(), mentioned_uids: mentionedUids }, (hasDeleteIds ? { delete_image_ids: deleteImageIds } : {})), (hasUnlinkIds ? { unlink_content_ids: unlinkContentIds } : {}))
            }
        });
    };
    ContentCommentApi.prototype.fetchMentionableUsers = function (_a) {
        var contentId = _a.contentId;
        var _b = this, basePath = _b.basePath, client = _b.client;
        return client.get(basePath + "/" + contentId + "/mentionable_users");
    };
    return ContentCommentApi;
}(BaseApiClient));
export default new ContentCommentApi();
